module.exports = __webpack_public_path__ + "static/media/hero-bcg5.5911ff1b.jpg";